<div class="col-md-12" *ngIf="visible">
  <div class="note-error" role="alert">
    <p class="error-title">
      <i class="fa fa-exclamation-triangle"></i>
      <strong>{{errorHeader}}</strong>
    </p>
    <p class="error-text" *ngIf="errorText">{{errorText}}</p>
    <p class="error-foot" *ngIf="errorFoot">{{errorFoot}}</p>
  </div>
</div>
